<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t1.title')"
      :textArray="[]"
    >
      <div slot="content">
        <span class="font-weight-bold">
          Hans-Lebrecht-Schule
        </span>
        <br>
        <span class="text-caption">
          {{ $t('imprint.t1.subtitle') }}
        </span>
        <br><br>
        Steinhövelstraße 7<br>
        89075 Ulm<br><br>
      </div>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t2.title')"
      :textArray="[]"
    >
      <div slot="content">
        Lucia Geitmann<br>
        <v-col
          v-if="emailAddressSchool"
          cols="12"
          class="py-2"
        >
          <ContactChip
            icon="mdi-email"
            :value="emailAddressSchool"
            :href="'mailto:' + emailAddressSchool"
          />
        </v-col>
      </div>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t3.title')"
      :textArray="[$t('imprint.t3.p0')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t4.title')"
      :textArray="[$t('imprint.t4.p0')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t5.title')"
      :textArray="[]"
    >
      <div slot="content">
        <span class="font-weight-bold">
          Widerstand und Soehne GmbH
        </span>
        <br>
        Prittwitzstr. 100<br>
        89075 Ulm<br>
        <v-col
          v-if="emailAddressWus"
          cols="12"
          class="py-2"
        >
          <ContactChip
            icon="mdi-email"
            :value="emailAddressWus"
            :href="'mailto:' + emailAddressWus"
          />
        </v-col>
        <v-col
          cols="12"
          align="center"
        >
          <ExternalLinkButton
            :themeColor="computedTopicColor"
            :href="homepageLinkWuS"
            :text="$t('imprint.t5.link')"
          />
        </v-col>
      </div>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('imprint.t6.title')"
      :textArray="[$t('imprint.t6.p0')]"
    />
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContactChip from '@/views/components/ContactChip.vue'
import ExternalLinkButton from '@/views/components/ExternalLinkButton.vue'

export default {
  name: 'Imprint',
  components: {
    ContentFrame,
    ContentTile,
    ContactChip,
    ExternalLinkButton
  },
  data () {
    return {
      emailAddressSchool: 'info@hans-lebrecht-schule.de',
      emailAddressWus: 'info@widerstand.digital',
      homepageLinkWuS: 'https://www.widerstand.digital'
    }
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.imprint.color
    },
    computedTitle () {
      return this.menuData.imprint.title
    }
  }
}
</script>

<style scoped>
  .v-data-table {
    border-radius: 0px !important;
  }
</style>
